import type { Lang } from '@/i18n/locale';
import type { FitnessGuidedCopy } from '@/i18n/fitnessExperienceTypes';
import { requireFitnessExperienceCopy } from '@/i18n/translations';
export type { FitnessGuidedCopy } from '@/i18n/fitnessExperienceTypes';

/** Synchronous after the shared locale boot/readiness boundary. */
export const getFitnessGuidedCopy = (lang: Lang): FitnessGuidedCopy => requireFitnessExperienceCopy(lang, 'guided');
